module.exports = __webpack_public_path__ + "static/media/illustration-stay-productive.99294b1f.png";